(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pw-eol-alternatives"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pw-eol-alternatives')) {
    customElements.define('pw-eol-alternatives', class extends HTMLElement {
      connectedCallback() {
        if (!this.dataset.url || this.dataset.loaded === 'true') return;
        this.dataset.loaded = 'true';

        fetch(this.dataset.url)
          .then((response) => {
            if (!response.ok) throw new Error('Recommendations request failed');
            return response.text();
          })
          .then((htmlText) => {
            const html = document.createElement('div');
            html.innerHTML = htmlText;
            const replacement = html.querySelector('pw-eol-alternatives');

            if (!replacement || !replacement.innerHTML.trim()) {
              this.remove();
              return;
            }

            this.innerHTML = replacement.innerHTML;
          })
          .catch(() => this.remove());
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
